import { observable, makeObservable } from 'mobx';

import { Price, PriceList, PurchasePriceList } from '@store/models/Price';
import { assertIsDefined } from '@utils/assertIsDefined';

export class PriceListStore {
    public static Name = 'priceListStore' as const;

    @observable public compositeServiceList = new PriceList();
    @observable public purchasePriceList = new PurchasePriceList();

    constructor() {
        makeObservable(this);
    }

    public isServiceComposite(serviceId: string): boolean {
        return !!this.compositeServiceList.getPriceByServiceId(serviceId);
    }

    public getCompositeServicePriceByServiceId(serviceId: string): Price {
        const price = this.compositeServiceList.getPriceByServiceId(serviceId);
        assertIsDefined(price, `Composite price of service ${serviceId} is read only after isServiceComposite check`);
        return price;
    }

    public getCompositeServiceIdsByServiceId(serviceId: string): string[] {
        const price = this.compositeServiceList.getPriceByServiceId(serviceId);
        return price?.includedServices ?? [];
    }
}

export const priceListStore = new PriceListStore();
